import { useContext } from "react";
import Layout from "../../../../../global/component/Genericos/Layout/Layout";
import Modal from "../../../../../global/component/Genericos/Modal/Modal";
import { GlobalContext } from "../../../../../global/context/Provider";
import { BodyContainerPASO, ContainerPaso, HeaderBar } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import { isNativeMobile } from "global/utils/platformDetector";

const LayoutPasos = ({
  volverTo,
  children,
  handleClick,
  title,
  subtitle,
  type,
  hideLogo,
  minSizeTxt,
}) => {
  const { modalState, configState } = useContext(GlobalContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  
  // Detectar si es app nativa o mobile web
  const isNativePlatform = isNativeMobile();

  const limpiar = () => {
    if (handleClick) {
      handleClick();
    } else {
      setPaso("Home")(pasoDispatch);
    }
  };

  // Función para resetear al home desde el burger mobile
  const resetToHome = () => {
    setPaso("Home")(pasoDispatch);
  };

  return (
    <Layout origen={"NULL"} nextFnc={resetToHome}>
      {modalState.modal.show && <Modal></Modal>}
      <ContainerPaso $isNative={isNativePlatform}>
        <HeaderBar circle={type === "no-circle" ? 0 : 1}>
          <div className="arrow" onClick={limpiar}>
            {"<"}
          </div>
          <h1 className={`title ${minSizeTxt ? "rb16m" : "rb18b"}`}>{title}</h1>
          {subtitle && <p className={`subtitle ${minSizeTxt ? "rb14l" : ""}`}>{subtitle}</p>}
        </HeaderBar>
        <BodyContainerPASO $hideLogo={hideLogo} $isNative={isNativePlatform}>
          {children}
          {configState.config.data &&
          configState.config.data.portal === "dim" ? (
            <div className="logo-dim">
              <LogoDim height={"550"} />
            </div>
          ) : (
            ""
          )}
        </BodyContainerPASO>
      </ContainerPaso>
    </Layout>
  );
};

export default LayoutPasos;
